<template>
  <div>
    <div class="home-container">
      <ContractsChartTile :datas="[]" :year="year"/>
      <RfaChartTile v-if="declarationYearPeriod"
                    :period="declarationYearPeriod"
                    :detailed-periods="detailedPeriods"
                    :concept="rfaTileConcept"
                    @concept-change="rfaTileConcept = $event"
      />
      <RfaChartTile v-if="advancePeriod"
                    :period="advancePeriod"
                    @period-change="advancePeriod=$event"
                    :detailed-periods="detailedPeriods"
      />
      <AppointmentsTile/>
      <EllisphereAlertsTile />
      <PrestationsTile :year="year" :current-year-period="currentYearPeriod"/>
      <StatsRecapTile v-if="statPeriod" :period="statPeriod" @period-change="statPeriod=$event"
                 :detailed-periods="detailedPeriods"/>
      <SimFixeAlertesBaisseTile />
      <SimFixePaliersSupTile />
      <StatsAlertsTile />
    </div>
  </div>
</template>

<script>
import ContractsChartTile from "@/components/Dashboards/ContractsChartTile.vue";
import RfaChartTile from "@/components/Dashboards/RfaChartTile.vue";
import dayjs from "dayjs";
import AppointmentsTile from "@/components/DashboardCdm/Appointments/AppointmentsTile.vue";
import PrestationsTile from "@/components/DashboardCdm/Prestations/PrestationsTile.vue";
import StatsRecapTile from "@/components/Dashboards/StatsRecapTile.vue";
import SimFixeAlertesBaisseTile from "@/components/DashboardCdm/Alertes/SimFixeAlertesBaisseTile.vue";
import SimFixePaliersSupTile from "@/components/DashboardCdm/Alertes/SimFixePaliersSupTile.vue";
import StatsAlertsTile from "@/components/DashboardCdm/Stats/StatsAlertsTile.vue";
import EllisphereAlertsTile from "@/components/Dashboards/EllisphereAlertsTile.vue";

export default {
  name: "Home",
  components: {
    EllisphereAlertsTile,
    StatsAlertsTile,
    SimFixePaliersSupTile,
    SimFixeAlertesBaisseTile, StatsRecapTile, PrestationsTile, AppointmentsTile, RfaChartTile, ContractsChartTile},
  props: ["year", "detailedPeriods"],
  data() {
    return {
      rfaTileConcept: 1,
      advancePeriod: null,
      statPeriod: null
    }
  },
  methods: {
    syncAdvancePeriod() {
      let period = null;
      this.advancePeriod = null;
      const now = dayjs();

      if (this.year < now.year()) {
        // C'est l'année précédente. On retourne le dernier acompte : T3
        period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 10 && dp.year == this.year);
      } else if (this.year > now.year()) {
        // Fin 2025 sélection contrats 2026. On affiche le T3 2025
        period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 10 && dp.year == this.year - 1);
      } else if (this.year == now.year()) {
        let t2Treshold = dayjs().month(6).date(15);
        let t3Treshold = dayjs().month(9).date(15);

        if (now.isAfter(t3Treshold)) {
          // On est après le 15 octobre, T3 disponibles
          period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 10 && dp.year == this.year);
        } else if (now.isAfter(t2Treshold)) {
          // On est après le 15 juillet, T2 disponibles
          period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 7 && dp.year == this.year);
        } else {
          // On affiche T1 par défaut
          period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 4 && dp.year == this.year);
        }
      }

      if (period) this.advancePeriod = period;
    },
    syncStatPeriod() {
      this.statPeriod = null;
      if (!this.detailedPeriods || !this.detailedPeriods.length) return;

      let refDate = dayjs().subtract(10, "days");

      let year = refDate.year();
      let month = refDate.month(); // on laisse indexé sur 0, car en février par ex. on veut la stat janvier

      if (month === 0) {
        month = 12;
        year -= 1;
      }

      this.statPeriod = this.detailedPeriods.find(dp => dp.declarationType == 1 && dp.month == month && dp.year == year);
    },
  },
  mounted() {
  },
  watch: {
    year() {
      this.syncAdvancePeriod();
      this.syncStatPeriod();
    },
    detailedPeriods() {
      this.syncAdvancePeriod();
      this.syncStatPeriod();
    }
  },
  computed: {
    currentYearPeriod() {
      if (!this.detailedPeriods || !this.detailedPeriods.length) return null;
      return this.detailedPeriods.find(dp => dp.declarationType == 3 && dp.year == this.year);
    },
    declarationYearPeriod() {
      // On récupère la déclaration annuelle N-1
      if (!this.detailedPeriods || !this.detailedPeriods.length) return null;
      return this.detailedPeriods.find(dp => dp.declarationType == 3 && dp.year == this.year - 1);
    },
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.home-container h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}
</style>

<style>
.home-container .white-box {
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Achat/DashboardCdm/Home.vue